/* eslint-disable react/jsx-closing-bracket-location */
import { Editor } from '@tinymce/tinymce-react';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import NotificationService from '../../../../Service/NotificationService';
import PageHeader from '../../../Common/PageHeader';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Divider } from '@material-ui/core';
import Swal from 'sweetalert2';
import EditIcon from '@material-ui/icons/Edit';

const RICH_TEXT_EDITOR_API_KEY = window.AppConfig.RICH_TEXT_EDITOR_API_KEY;

class UpdateEmails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			key: '',
			locale: '',
			subject: '',
			body: '',
			template_name: '',
			isLoading: false,
			isSaved: false
		};
	}

	handleEditorChange = emailTemplate => {
		this.setState({
			body: emailTemplate
		});
	};

	updateEmail = async () => {
		const requestBody = {
			locale: this.state.locale,
			subject: this.state.subject,
			body: this.state.body,
			key: this.state.key,
			template_name: this.state.template_name
		};
		this.setState({ isSaved: true });
		await NotificationService.updateEmailTemplate(this.props.match.params.id, requestBody);
		await this.fetchEmail();
	};

	fetchEmail = async () => {
		this.setState({ isLoading: true, isSaved: false });
		const resp = await NotificationService.getOneEmailTemplates(
			this.props.match.params.id,
			this.props.match.params.key,
			this.props.match.params.locale
		);
		this.setState({
			key: resp.key,
			locale: resp.locale,
			subject: resp.subject,
			body: resp.body,
			template_name: resp.template_name,
			isLoading: false
		});
	};

	componentDidMount() {
		this.fetchEmail();
	}

	updateSubjectOrTemplateName(name) {
		Swal.fire({
			
			title: name === 'template' ? 'Edit Template Name' : 'Edit Subject Line',
			input: 'text',
			inputValue: name === 'template' ? this.state.template_name : this.state.subject,
			showCancelButton: true,
			confirmButtonText: 'Update',
			showLoaderOnConfirm: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			customClass: 'otp_message_success'
		}).then(result => {
			if (result.value) {
				if (name === 'template') {
					this.setState({ template_name: result.value });
				} else if (name === 'subject') {
					this.setState({ subject: result.value });
				}
			}
		});
	}

	render() {
		if (this.state.isLoading) {
			return 'Loading...';
		}
		return (
			<>
				<PageHeader text={`Email template - ${this.state.template_name}`}>
					<div className="col-sm-2" style={{ marginTop: 'auto' }}>
						<EditIcon
							style={{ cursor: 'pointer' }}
							onClick={() => {
								this.updateSubjectOrTemplateName('template');
							}}>
							Edit Name
						</EditIcon>
					</div>
				</PageHeader>
				<Divider style={{ color: 'black' }} />
				<PageHeader text={`Subject Line - ${this.state.subject}`}>
					<div className="col-sm-2" style={{ marginTop: '10px' }}>
						<EditIcon
							style={{ cursor: 'pointer' }}
							onClick={() => {
								this.updateSubjectOrTemplateName('subject');
							}}>
							Edit Subject
						</EditIcon>
					</div>
				</PageHeader>
				<Editor
					apiKey={RICH_TEXT_EDITOR_API_KEY}
					init={{
						height: 500,
						menubar: false,
						plugins: [
							'advlist autolink lists link image charmap print preview anchor',
							'searchreplace visualblocks code fullscreen',
							'insertdatetime media table paste code help wordcount',
							'textcolor'
						],
						toolbar: `undo redo | formatselect fontstyle | forecolor fontsizeselect | bold italic
                alignleft aligncenter alignright alignjustify
                bullist numlist outdent indent | removeformat | link image | help`
					}}
					initialValue={`${this.state.body}`}
					onEditorChange={this.handleEditorChange}
				/>
				<br />
				<button
					className="btn btn-block btn-success"
					onClick={this.updateEmail}
					style={{ width: '15%', marginLeft: '40%' }}
					type="button">
					Save
					{this.state.isSaved ? <CircularProgress disableShrink size={18} style={{ color: 'white' }} /> : ''}
				</button>
				<br />
				<Link to={`/admin/tenant/email-templates/${this.props.match.params.id}`}>
					<button
						className="btn btn-block btn-primary"
						style={{ width: '15%', marginLeft: '40%' }}
						type="button">
						Back
					</button>
				</Link>
			</>
		);
	}
}

export default withRouter(UpdateEmails);
